module.exports = function () {
  return new Worker(__webpack_public_path__ + "7a6e29c17f1955a9e452.worker.js");
};